import { MainV3ApiBase } from './base';
import { EventId } from '../../commonv3/types/events';
import { EventWaitlistId } from '../../commonv3/types/eventWaitlists';
import { EventWaitlistIndexView } from '../types/eventWaitlists';

export const EventWaitlistApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/event_waitlists');
    },
    findAll(): Promise<EventWaitlistIndexView[]> {
        return this.base().get();
    },
    create(eventId: EventId): Promise<EventWaitlistIndexView> {
        return this.base().post({ event_id: eventId });
    },
    cancel(eventWaitlistId: EventWaitlistId): Promise<EventWaitlistIndexView> {
        return this.base()
            .withId(eventWaitlistId)
            .put({ status: 'cancelled' });
    },
};
